<div class="container-fluid">
  <div class="row">
    <div class="col-xl-2">
      <app-side-filters (childButtonEvent)="receivedMessageHandler($event)"
        (onInitEvent)="receiveAutoMsgHandler($event)"></app-side-filters>
    </div>
    <div class="col-xl-10">
      <!-- <div class="box blue">{{msgOnButtonClick}}</div> -->
      <h1 class="page-hd">Document Verification List</h1>
      <button class="page-btn bg-theme" (click)="callDispute(2)">Apply for Verification</button>
      <div class="content-wrap">
        <div class="table-responsive">
          <table class="ui celled table hover" datatable [dtTrigger]="dtTrigger" [dtOptions]="dtOptions">
            <thead>
              <tr>
                <th *ngIf="hideId">Id</th>
                <th>Application Id</th>
                <th>Name</th>
                <th>Seat No.</th>
                <!-- <th>Passing Month</th> -->
                <th>Passing Year</th>
                <th>Stream</th>
                <th>Branch</th>
                <th>Semester</th>
                <th>Document</th>
                <th>Status</th>
                <th>Requested Date</th>
                <!-- <th>Request Type</th> -->
                <th>Download Invoice</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of request ">
                <td *ngIf="hideId">{{data.id}}</td>
                <td>{{data.application_id}}</td>
                <td>{{data.first_name +" "+ data.last_name}}</td>
                <td>{{data.enroll_no}}</td>
                <td>{{data.monthOfPassing}}/{{data.year}}</td>
                <td>{{data.stream_name}}</td>
                <td>{{data.branch_nm}}</td>
                <td>{{data.semester}}</td>
                <td>{{data.doc_name}}</td>
                <!-- <td >{{data.doc_status }}</td> -->
                <td
                  *ngIf="data.doc_status=='Rejected'||data.doc_status=='Approved' || data.doc_status=='SV_Approved'||data.doc_status=='Approved_Pass' || data.doc_status=='SV_Approved_Pass'||data.doc_status=='Approved_Fail' || data.doc_status=='SV_Approved_Fail'  || data.doc_status=='SV_Rejected' ||data.doc_status=='Requested' || data.doc_status=='Unable To Verify'|| data.doc_status=='Offline'|| data.doc_status=='SV_Unable To Verify'|| data.doc_status=='SV_Offline' || data.doc_status=='Ver_Request_Edit' || data.doc_status=='Uni_Request_Edit' ">
                  Open
                </td>
                <td
                  *ngIf="data.doc_status=='UN_Approved'||data.doc_status=='UN_Approved_Pass' ||data.doc_status=='UN_Approved_Fail'  ||data.doc_status=='UN_Rejected' || data.doc_status=='Uni_Auto_Approved'|| data.doc_status=='Uni_Auto_Rejected'|| data.doc_status=='SVD_Rejected'|| data.doc_status=='SVD_Approved' || data.doc_status=='SVD_Approved_Pass'|| data.doc_status=='SVD_Approved_Fail'">
                  Closed
                </td>
                <td>{{data.req_date}}</td>

                <td>
                  <button class='action-btn bg-theme' (click)="downloadPDF(data.application_id)"><i
                      class="fa fa-download download-icon" aria-hidden="true"></i> Download</button>

                      <button class='action-btn bg-theme ml-2' (click)="downloadCertificate(data.id,data.doc_status)"  *ngIf="data.doc_status=='UN_Approved'||data.doc_status=='UN_Approved_Pass' ||data.doc_status=='UN_Approved_Fail'  ||data.doc_status=='UN_Rejected' || data.doc_status=='Uni_Auto_Approved'|| data.doc_status=='Uni_Auto_Rejected'|| data.doc_status=='SVD_Rejected'|| data.doc_status=='SVD_Approved' || data.doc_status=='SVD_Approved_Pass'|| data.doc_status=='SVD_Approved_Fail'">
                        <i class="fa fa-download download-icon"  aria-hidden="true"></i>Download Certificate</button>

                      <button class="action-btn bg-grey ml-2" *ngIf=" data.doc_status=='Ver_Request_Edit' || data.doc_status=='Uni_Request_Edit'" (click)="editVerification(data.id, 3)">Edit</button>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
        <p class="dispute-link"><a (click)="callDispute(1)">Raise Dispute</a></p>
      </div>
      `
    </div>
  </div>
</div>

<div class="modal fade" id="viewModal" tabindex="-1" role="dialog" aria-labelledby="viewModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="viewModalLabel">Preview Document</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <img src="assets/images/certificate.jpg" alt="Certificate" class="doc-img">
            <p class="doc-txt">To be verified</p>
          </div>
          <div class="col-md-6">
            <img src="assets/images/certificate.jpg" alt="Certificate" class="doc-img">
            <p class="doc-txt">System document</p>
          </div>
        </div>
        <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal">Positive</button>
        <button class="reject-modal-btn mr-auto" data-dismiss="modal">Negative</button>
        <button class="utv-modal-btn mr-auto" data-dismiss="modal">Unable to verify</button>
        <button class="offline-modal-btn mr-auto" data-dismiss="modal">Offline verification</button>
      </div>
    </div>
  </div>
</div>